import { render, staticRenderFns } from "./EditRequest.vue?vue&type=template&id=530dc41d&"
import script from "./EditRequest.ts?vue&type=script&lang=ts&"
export * from "./EditRequest.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports